import { Flex } from '@mantine/core';
import { Text } from '../../../../../ui-library/typography/typography';
import { LineChartLegendMarker } from './line-chart-legend-marker';

interface Props {
  value: string;
  label: string;
  color: string;
  isHovered: boolean;
  onMouseEnter: (itemId: string) => void;
  onMouseLeave: () => void;
}

export const LineChartLegendItem = ({ value, label, color, isHovered, onMouseEnter, onMouseLeave }: Props) => {
  return (
    <Flex
      key={value}
      align="center"
      gap={4}
      style={{
        cursor: 'pointer',
        opacity: isHovered ? 1 : 0.3,
        transition: 'opacity 0.2s ease',
      }}
      onMouseEnter={() => onMouseEnter(value)}
      onMouseLeave={onMouseLeave}
    >
      <LineChartLegendMarker color={color} />
      <Text size="tiny">{label}</Text>
    </Flex>
  );
};
